export const CASH_POOLING_LABELS = {
  EXCESS: {
    NAME: "Transferir Excedente",
    DESCRIPTION:
      "Transfira automaticamente o valor excedente quando o saldo ultrapassar o limite máximo.",
    PAGE_SUBHEADER:
      "Configure uma regra para transferir automaticamente o valor excedente para outra conta",
  },
  MINIMUM: {
    NAME: "Manter Mínimo",
    DESCRIPTION:
      "Receba automaticamente fundos quando o saldo estiver abaixo do mínimo necessário.",
    PAGE_SUBHEADER:
      "Configure uma regra para receber automaticamente dinheiro quando o saldo estiver abaixo do mínimo",
  },
  FIXED: {
    NAME: "Transferência Recorrente",
    DESCRIPTION:
      "Configure transferências periódicas de valor fixo entre contas.",
    PAGE_SUBHEADER:
      "Configure uma regra para transferir automaticamente um valor fixo para outra conta",
  }
} as const;
